import { connect } from 'react-redux'
import { Home } from './index'
import { mapStateToProps } from './index.props'

export const HomeStore = connect(mapStateToProps, null)(Home)
